
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Order from '../Order/Order';
import Redirect from '../Redirect/Redirect';

function App() {

  return (
    <div className='app'>
      <Routes>
        <Route path='/order/:id' element={<Order />} />
        <Route path='*' element={<Redirect />} />
      </Routes>
    </div>
  );
}

export default App;
